import React, { useState, useEffect } from 'react';
import { useCreateServiceGroupMutation } from '../../../generated/graphql';
import ModalDialog from '../ModalDialog';
import { customToast } from '../ToastAlert/customToast';
import InputGroup from '../InputGroup';

interface CreateGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const CreateGroupModal: React.FC<CreateGroupModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [name, setName] = useState('');
  const [createServiceGroup, { loading }] = useCreateServiceGroupMutation();

  useEffect(() => {
    if (isOpen) {
      setName('');
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      customToast.error('Group name is required');
      return;
    }

    try {
      await createServiceGroup({
        variables: {
          input: {
            name: name.trim(),
          },
        },
        refetchQueries: ['ServiceGroups'],
      });
      setName('');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Failed to create group:', error);
      customToast.error('Failed to create group');
    }
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      setClosed={onClose}
      width="small"
      title="Add Service Group"
      primaryActionTitle={loading ? 'Adding...' : 'Add service group'}
      primaryActionOnClick={handleSubmit}
      primaryActionDisabled={loading || !name.trim()}
      primaryActionOnEnter={true}
    >
      <div className="flex items-center justify-center pb-2">
        <InputGroup
          inputSize="small"
          label="Service group name"
          containerClassName="w-full"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g., Consultation Services"
          autoFocus
        />
      </div>
    </ModalDialog>
  );
};

export default CreateGroupModal;
